// import React from 'react';

export default function NewMessagePage() {
  return null;
}
